import { filterEntityType } from 'utils/constants';

export const DYNAMIC_COLUMN_FIELD_PREFIX = 'dyn_';

export const getDynamicPropertyValue = (row, propertyId) => {
  const values = row?.dynamic_properties_values || {};
  return values[propertyId];
};

export const getResolvedTenantId = (row, tenantDynamicPropertyId) => {
  const dynamicValues = row?.dynamic_properties_values || {};
  const hasDynamicProperty =
    !!tenantDynamicPropertyId &&
    Object.prototype.hasOwnProperty.call(dynamicValues, tenantDynamicPropertyId);

  let fallbackTenantId = row?.tenant_id;
  if (hasDynamicProperty) {
    fallbackTenantId =
      dynamicValues[tenantDynamicPropertyId] === null
        ? 'vacant'
        : dynamicValues[tenantDynamicPropertyId];
  }

  return fallbackTenantId;
};

export const getDynamicPropertyType = property => property?.type || property?.dynamic_property_type;

export const isTenantProperty = property =>
  getDynamicPropertyType(property) === filterEntityType.tenant;

export const getTenantDynamicPropertyId = (dynamicProperties, isProjectRSO) => {
  if (!isProjectRSO) return undefined;
  return (dynamicProperties || []).find(isTenantProperty)?.id;
};

export const isPropertyPresentInRows = (property, rows) => {
  const propertyId = property?.id;
  if (!propertyId) return false;
  return (rows || []).some(row => {
    const values = row?.dynamic_properties_values;
    return values != null && Object.prototype.hasOwnProperty.call(values, propertyId);
  });
};

export const filterProjectVisibleDynamicProperties = (dynamicProperties, { isProjectRSO }) =>
  isProjectRSO
    ? dynamicProperties || []
    : (dynamicProperties || []).filter(property => !isTenantProperty(property));

export const applyTenantFilterTransform = (filters, tenantDynamicPropertyId) => {
  if (!filters) return {};

  const tenantFilters = filters?.tenant_ids || [];
  if (!tenantFilters.length || !tenantDynamicPropertyId) return filters;

  // Backend API mapping for tenant filter values:
  //   null ("no tenant" / unassigned) → ""   (empty string)
  //   "vacant" (vacant unit)          → null  (null in the body)
  //   <uuid>  (specific tenant)       → <uuid> (unchanged)
  const transformedTenantIds = tenantFilters.map(tenantFilter => {
    const id =
      typeof tenantFilter === 'object' && tenantFilter !== null ? tenantFilter.id : tenantFilter;
    if (id === null) return ''; // "No tenant" is expected as an empty string by the API
    if (id === 'vacant') return null; // "Vacant unit" is expected as null by the API
    return id; // Specific tenant (UUID)
  });

  const { tenant_ids: _tenantIds, ...restFilters } = filters;

  return {
    ...restFilters,
    dynamic_properties_values: {
      ...(restFilters.dynamic_properties_values || {}),
      [tenantDynamicPropertyId]: transformedTenantIds,
    },
  };
};

// Inverse of applyTenantFilterTransform value mapping, used when hydrating a saved
// report back into the tenant filter:
//   "" (empty string) → null     ("No tenant")
//   null              → "vacant" ("Vacant unit")
//   <uuid>            → <uuid>   (unchanged)
export const mapStoredTenantIdToFilterId = storedId => {
  if (storedId === '') return null;
  if (storedId === null) return 'vacant';
  return storedId;
};
